import t from"vue";var a=t.extend({inject:["$amapMap"],computed:{$map:function(){return this.$amapMap.target}}});export default a;
